import { FetchHttpClient } from "@effect/platform";
import { Layer } from "effect";

/** `FetchHttpClient` passes a `URL`, but page scripts that patch `window.fetch`
 * often handle only `string`/`Request` (Fast Bundle throws on it, pre-send). */
export const browserSafeFetch: typeof globalThis.fetch = (input, init) =>
  globalThis.fetch(input instanceof URL ? input.href : input, init);

/** Drop-in replacement for `FetchHttpClient.layer` in browser bundles. */
export const browserSafeFetchHttpClientLayer = FetchHttpClient.layer.pipe(
  Layer.provide(Layer.succeed(FetchHttpClient.Fetch, browserSafeFetch)),
);
